import { useQuery } from "react-query";

import { fusionAuthService } from "services";

const useGetFusionAuthUsersQuery = ({ userId }: { userId: string }) => {
	const queryResult = useQuery(
		["fusionAuthUsersQuery", userId],
		() =>
			fusionAuthService.getFusionAuthUsers({
				userId,
			}),
		{
			retry: 0,
			cacheTime: 0,
			enabled: !!userId,
		},
	);

	return queryResult;
};

export default useGetFusionAuthUsersQuery;
